import { problems } from "@/mocks/problems";

const colorStyles = [
  {
    bubble: "bg-primary-100 text-primary-700",
    pill: "bg-primary-50 text-primary-700",
    hover: "hover:border-primary-300 hover:shadow-soft",
  },
  {
    bubble: "bg-accent-100 text-accent-700",
    pill: "bg-accent-50 text-accent-700",
    hover: "hover:border-accent-300 hover:shadow-soft",
  },
  {
    bubble: "bg-secondary-100 text-secondary-700",
    pill: "bg-secondary-50 text-secondary-700",
    hover: "hover:border-secondary-300 hover:shadow-soft",
  },
];

export default function ProblemNav() {
  const jump = (id: string) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="problems" className="mx-auto max-w-7xl scroll-mt-20 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <span className="inline-block rounded-full bg-secondary-100 px-4 py-1 text-sm font-medium text-secondary-900">
          遇到哪种问题？
        </span>
        <h2 className="mt-4 text-2xl font-black text-foreground-950 md:text-4xl">
          六大常见问题，点击即查
        </h2>
        <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-base">
          我们把笔笔漫画网使用中最常遇到的六类问题整理成了分类卡片，
          点进去就能看到对应的排查步骤，按顺序操作即可。
        </p>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {problems.map((p, i) => {
          const c = colorStyles[i % colorStyles.length];
          return (
            <button
              key={p.id}
              onClick={() => jump(p.id)}
              className={`group flex flex-col rounded-2xl border border-background-200 bg-background-50 p-6 text-left transition-all ${c.hover}`}
            >
              <div className="flex items-center justify-between">
                <span
                  className={`flex h-12 w-12 items-center justify-center rounded-xl text-2xl ${c.bubble}`}
                >
                  <i className={p.icon} />
                </span>
                <span className={`rounded-full px-3 py-1 text-xs font-medium ${c.pill}`}>
                  {p.keyword}
                </span>
              </div>
              <h3 className="mt-5 text-lg font-bold text-foreground-950">{p.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">{p.brief}</p>
              <span className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-primary-600 transition-transform group-hover:translate-x-1">
                查看解决方案
                <i className="ri-arrow-right-line" />
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}